import { render } from "./TextImageSection.vue?vue&type=template&id=11c7d22b&scoped=true"
import script from "./TextImageSection.vue?vue&type=script&lang=js"
export * from "./TextImageSection.vue?vue&type=script&lang=js"

import "./TextImageSection.vue?vue&type=style&index=0&id=11c7d22b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11c7d22b"

export default script